 <!-- 我的报名 -->
<template>
  <div class="enroll">
    <div class="head">
      <div class="head-left"> 
        <p class="title">我的证书</p>
      </div>
    </div>
    <div class="certificate">
      <span class="certificate-obtained">已获得</span>
      <ul class="certificate-ul">
        <li class="certificate-ul-li" v-for="item,index in userCertList" :key="index">
          <el-image
            style="width: 160px; height: 110px; margin-right: 46px;"
            :src="item.certPath" 
            :preview-src-list="[item.certPath]">
          </el-image>
          <div class="certificate-ul-li-content">
            <div class="certificate-ul-li-content-name" style="width: 33%;">
              <p class="certificate-ul-li-content-name-key">证书名称</p>
              <p class="certificate-ul-li-content-name-val">{{item.certName}}</p>
            </div>
            <div class="certificate-ul-li-content-name" style="width: 25%;">
              <p class="certificate-ul-li-content-name-key">获得时间</p>
              <p class="certificate-ul-li-content-name-val">{{item.createTime}}</p>
            </div>
            <div class="certificate-ul-li-content-download">
              <div @click.stop="downloadFile(item.certPath)"> 
                <img src="../../assets/img/icon34.png">
                <span>下载</span>
              </div>
              <p>|</p>
              <input type="text" v-model="item.certPath" style="display: none;"/>
              <el-popover
                placement="top-start"
                trigger="hover">
                <div @click="copyText(item.id)" class="certificate-ul-li-content-share">
                  <img src="../../assets/img/icon35.png">
                  <p>复制分享链接</p>
                </div>
                <div slot="reference">
                  <img src="../../assets/img/icon35.png">
                  <span>分享</span>
                </div>
              </el-popover>
            </div>
          </div>
        </li>
        
      </ul>
    </div>
    <div class="certificate">
      <span class="certificate-obtained">待申请</span>
      <ul class="certificate-ul" style="display: flex;flex-wrap: wrap; justify-content: space-between;">
        <li class="certificate-ul-item" v-for="item,index in certificateList" :key="index">
          <el-image
            style="width: 100%;"
            :src="item.certImg" 
            :preview-src-list="[item.certImg]">
          </el-image>
          <p class="certificate-ul-item-name">{{item.certName}}</p>
          <el-button v-if="item.applyStatus == 0" type="warning" size="small" style="width: 100%;background-color: #ff821c" @click="onCertificateDetails(item.id,2)">立即申请</el-button>
          <el-button v-else-if="item.applyStatus == 1" type="warning" size="small" style="width: 100%;" @click="onCertificateDetails(item.id,2)">审核中</el-button>
          <el-button v-else-if="item.applyStatus == 3" type="warning" size="small" style="width: 100%;background-color: #ff821c" @click="onCertificateDetails(item.id,2)">重新申请</el-button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {userCertList,getShare} from '../../api/userMG'
import axios from 'axios';
export default {
  data() {
    return {
      urls: 'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
      srcList: [
        'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg'
      ],
      userCertList:[],
      certificateList:[],
      visible:''
    }
  },
  computed: {
    url() {
      return this.$store.getters.url;
    }
  },
  created() {
    this.getCertList();
  },
  methods:{
    async getCertList(){
      await userCertList().then(res => {
        console.log('我的证书',res);
        this.userCertList = res.data.userCertList;
        this.certificateList = res.data.certificateList;
      })
      .catch(err => {
        
      })
    },
    onCertificateDetails(id,index){
      this.$router.push({path:'/certificate/certificateDetails', query: { id: id,index:index }})
    },
    downloadFile(fileName) {
      const loading = this.$loading({
        lock: true,
        text: '下载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      window.location.href = fileName;
      loading.close();
    },

    // 复制
    copyText(id){
      getShare({certId:id}).then(res => {
        console.log('获取分享链接',res.data);
        const input = document.createElement('input');
        // input.value = this.url+'index/preview?certPath='+res.data; // 设置要复制的文本
        input.value = res.data; // 设置要复制的文本
        document.body.appendChild(input); // 添加input元素
        input.select(); // 选中文本
        document.execCommand('copy'); // 执行复制操作
        document.body.removeChild(input); // 移除input元素
        this.$message({
          message: '已复制',
          type: 'success',
          offset:100
        })
      })

    }
  }
}
</script>

<style scoped>
  .enroll{
    padding: 30px 20px;
    background-image: linear-gradient(bottom,#fff,#fff8f2);
    border: 1px solid #e1e2e6;
    border-radius: 8px;
  }
  .head{
    display: flex;
    justify-content: space-between;
    border-bottom: solid 1px #e6e6e6;
  }
  .head .title{
    font-size: 14px;
    font-weight: 500;
    color: black;
    letter-spacing: 1px;
    margin-bottom: 15px;
  }

  .certificate{
    padding: 26px 0 0;
  }
  .certificate-obtained{
    font-size: 14px;
    color: #f25902;
    padding: 10px 6px;
    border-bottom: 2px solid #f25902;
    margin: 0 4px;
  }
  .certificate-ul{
    margin: 36px 0 0;
  }
  .certificate-ul-li{
    border: 1px solid #d6d6d6;
    padding: 14px 12px;
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }
  .certificate-ul-li-content{
    display: flex;
    flex: 1;
    /* align-items: center; */
  }
  .certificate-ul-li-content-name{
    margin-right: 60px;
  }
  .certificate-ul-li-content-name-key{
    font-size: 12px;
    color: #9a9a9a;
    margin-bottom: 17px;
  }
  .certificate-ul-li-content-name-val{
    font-size: 13px;
    color: black;
  }
  .certificate-ul-li-content-download{
    display: flex;
    flex: 1;
    justify-content: flex-end;
  }
  .certificate-ul-li-content-download div{
    margin: 0 10px;
    display: flex;
    cursor: pointer;
  }
  .certificate-ul-li-content-download p{
    font-size: 12px;
    color: #e3e3e3;
    margin: 0 8px;
  }
  .certificate-ul-li-content-download img{
    width: 14px;
    height: 14px;
    margin-right: 6px;
  }
  .certificate-ul-li-content-download span{
    font-size: 12px;
    color: #f25902;
  }
  .certificate-ul-li-content-share{
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .certificate-ul-li-content-share img{
    width: 12px;
    height: 12px;
    margin-right: 12px;
  }
  .certificate-ul-li-content-share p{
    font-size: 13px;
    color: #797979;
  }
  .certificate-ul-item{
    width: 28%;
    padding: 12px;
    border: 1px solid #d6d6d6;
    /* margin-right: 12px; */
    margin-bottom: 18px;
  }
  /* .certificate-ul-item:nth-child(3), .certificate-ul-item:nth-child(6) {
    margin-right: 0;
  } */
  .certificate-ul-item-name{
    text-align: center;
    font-size: 13px;
    color: black;
    padding: 8px 0 10px;
  }
</style>


// WEBPACK FOOTER //
// src/views/certificate/certificate.vue